export default __webpack_public_path__ + "static/media/logo_b@3x.ec35a5e1.png";